import { Post } from './post.model';
import {Product, SubProduct} from './product.model';

export interface IPostProduct {
  id?:Object;
  product?: Product;
  post?: Post;
  price?: number;
  productID?: string;
  finalPrice?: number;
  allowDelivery?: boolean;
  pickFormShop?: boolean;
  unitDeliveryDuration?: string;
  deliveryDelay?: string;
  photo?: string;
}

export class PostProduct  implements IPostProduct {
  constructor(
    public id?: Object,
    public product?: Product,
    public post?: Post,
    public price?: number,
    public productID?: string,
    public  allowDelivery?: boolean,
    public  pickFormShop?: boolean,
    public unitDeliveryDuration?: string,
    public deliveryDelay?: string,
    public photo?: string
  ){
    this.id = id;
    this.product = product;
    this.post = post;
    this.price = price;
    this.productID = productID;
    this.allowDelivery = allowDelivery;
    this.pickFormShop = pickFormShop;
    this.unitDeliveryDuration = unitDeliveryDuration;
    this.deliveryDelay = deliveryDelay;
    this.photo = photo;
  }
}

export interface IPostSubProduct {
  id?:Object;
  subProduct?: SubProduct;
  post?: Post;
  price?: number;
  productID?: string;
  finalPrice?: number;
  allowDelivery?: boolean;
  pickFormShop?: boolean;
  unitDeliveryDuration?: string;
  deliveryDelay?: string;
}
